import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ConfigService } from '../configuration/config.service';
import { EidAuthService } from './services/eid-auth.service';
import { EidCallbackComponent } from './eid-callback/eid-callback.component';
import { EidAppswitchComponent } from './eid-appswitch/eid-appswitch.component';
import { SharedModule } from '@app/shared/shared.module';
import { SignedOutComponent } from './signed-out/signed-out.component';
import { EidSessionService } from './services/eid-session.service';
import { CookieService } from 'ngx-cookie-service';
import { EidLoggedInComponent } from './eid-logged-in/eid-logged-in.component';
import { EIDSDK_PROVIDER, EIDSDK } from './providers/eid-sdk.provider';
import { eidAppInitializer } from './eid-app-initializer';

@NgModule({
  declarations: [EidAppswitchComponent, EidCallbackComponent, SignedOutComponent, EidLoggedInComponent],
  imports: [SharedModule],
  providers: [
    EidAuthService,
    EidSessionService,
    CookieService,
    EIDSDK_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: eidAppInitializer,
      multi: true,
      deps: [EIDSDK, ConfigService]
    }
  ]
})
export class AuthConfigModule {}